var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon-svg",attrs:{"aria-hidden":"true"}},'svg',_vm.$attrs,false),_vm.$listeners),[(_vm.hasSymbol)?_c('use',{attrs:{"xlink:href":_vm.iconName}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }